import React from "react";
import moment from "moment";
import favIcon from "../../Assets/favicon.ico";
import { formatDate } from "../../helper/formatDate";
import "./entryCard.css";

// A family's entry in one event (MC2 ecbc86f7): the same card on the parent
// dashboard (with the event's crest, name, date and place on top; tapping
// them opens the event page) and on the event page (whose hero already
// names the event). Each dancer with Edit and their number card, what
// they dance by level (in columns, each 2nd chance under its dance) with how many are in each competition once the
// organiser opens the counts, and the card's buttons. Its layout follows
// the card's own width (container queries), so it reads the same in the
// dashboard feed and on the wider event page.

const Icon = ({ name }) => <span className="msr" aria-hidden="true">{name}</span>;
const plural = (n) => `${n} ${n === 1 ? "dancer" : "dancers"}`;
// each dance with the 2nd chance rows that follow it, one cell per dance
const groupRows = (rows) =>
  rows.reduce((out, r) => {
    if (r.sub && out.length) out[out.length - 1].subs.push(r);
    else out.push({ ...r, subs: [] });
    return out;
  }, []);
const longDay = (d) => (d ? moment(formatDate(d)).format("dddd, MMMM D, YYYY") : "");

const EntryCard = ({ event, kind = "feis", showEvent = false, today = false, onOpen, entries = [], counts = null, actions = [], notice = "" }) => {
  const eventDay = kind === "grade" ? event?.exam_date : event?.feis_date;
  const place = [event?.venue_city, event?.state].filter(Boolean).join(", ");
  const noun = { feis: "Feis", grade: "Grade exam", oireachtas: "Oireachtas" }[kind];
  return (
    <div className={`ec${today ? " ec--today" : ""}`}>
      <div className="ec-in">
        {showEvent && (
          <button type="button" className="ec-event" onClick={onOpen}>
            <img className="ec-logo" src={event?.logo || favIcon} alt="" />
            <span className="ec-event-text">
              <span className="ec-eyebrow">
                {noun}
                {today ? " · Today" : " · Entered"}
              </span>
              <span className="ec-event-name">{event?.name}</span>
              <span className="ec-event-when">{[longDay(eventDay), place].filter(Boolean).join(" · ")}</span>
            </span>
            <Icon name="chevron_right" />
          </button>
        )}

        <div className="ec-body">
          <div className="ec-entries">
            {entries.map((e) => (
              <div className="ec-entry" key={e.id}>
                <div className="ec-entry-head">
                  <span className="ec-name">
                    {e.name}
                    {e.count && <small>{e.count}</small>}
                  </span>
                  <span className="ec-entry-acts">
                    {!e.active && <span className="ec-gone">Deleted dancer</span>}
                    {e.onChange && (
                      <button type="button" className="ec-link" onClick={e.onChange}>
                        <Icon name="edit" /> Edit
                      </button>
                    )}
                    {e.print && (
                      <button type="button" className="ec-link" disabled={!e.print.available} onClick={e.print.onClick} title={e.print.available ? undefined : "Ready once the organiser finishes merges and splits"}>
                        <Icon name="print" /> {e.print.label}
                      </button>
                    )}
                  </span>
                </div>
                {e.sections.map((sec) => (
                  <div className="ec-sec" key={sec.key}>
                    <span className="ec-level">{sec.title}</span>
                    <ul className="ec-dances">
                      {groupRows(sec.rows).map((r) => {
                        const n = (row) => (counts && row.code ? counts.get(row.code) || 0 : null);
                        const line = (row, label) => (
                          <span className="ec-dance" key={row.id}>
                            <span className="ec-dance-name">
                              {label}
                              {row.age && <span className="ec-age"> {row.age}</span>}
                            </span>
                            {n(row) !== null && <span className="ec-count">{plural(n(row))}</span>}
                          </span>
                        );
                        return (
                          <li key={r.id}>
                            {line(r, r.secondOnly ? `${r.name} · 2nd chance` : r.name)}
                            {r.subs.map((sub) => (
                              <span className="ec-sub" key={sub.id}>
                                {line(sub, sub.name)}
                              </span>
                            ))}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                ))}
              </div>
            ))}
          </div>

          {actions.length > 0 && (
            <div className="ec-acts">
              {actions.map((a) => (
                <button key={a.key} type="button" className={`ec-btn${a.primary ? " primary" : ""}`} disabled={a.disabled} onClick={a.onClick}>
                  {a.icon && <Icon name={a.icon} />}
                  {a.label}
                </button>
              ))}
            </div>
          )}
        </div>
        {notice && (
          <p className="ec-notice" role="alert">
            {notice}
          </p>
        )}
      </div>
    </div>
  );
};

export default EntryCard;
